import React, { useState, useEffect, useMemo } from 'react';
import { Button, Form, Modal } from "react-bootstrap";
import { Controller, useForm } from 'react-hook-form';
// import { useAddCompanyMutation, useEditCompanyMutation } from '../../redux/services/companyService';
import LoadingButtonWithForm from '../../components/LoadingButtonWithForm';
import { sweetAlert } from '../../utils';
import { responseError } from '../../helpers/responseHandler';
import PhoneInput from 'react-phone-input-2';

const AddCompanyModal = ({ show, handleClose, isEdit }) => {
    const [countries, setCountries] = useState([]);
    const [states, setStates] = useState([]);
    const [cities, setCities] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState('');
    const [selectedState, setSelectedState] = useState('');

    let {
        control,
        register,
        handleSubmit,
        setValue,
        watch,
        reset,
        formState: { errors },
    } = useForm()

    // const [addRequest, { isLoading: addLoading }] = useAddCompanyMutation()
    // const [editRequest, { isLoading: editLoading }] = useEditCompanyMutation()


    const onSubmit = async (data) => {
        if (isEdit) {
            const newForm = { ...data }
            /*await editRequest({ id: isEdit?.id, newForm }).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })*/
        } else {
            const newForm = { ...data }
            /*await addRequest(newForm).unwrap()
                .then((res) => {
                    if (res?.status) {
                        sweetAlert(res?.message, 'success')
                        // navigate(-1)
                        handleClose()
                    }
                })
                .catch((err) => {
                    responseError(err)
                })*/
        }
    }













    return (
        <>
            <Modal show={show} size="lg" onHide={handleClose}>
                <Modal.Header className="border-0" closeButton>
                    <Modal.Title className="h5">{isEdit ? 'Create' : 'Edit'} Permits</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit(onSubmit)} id='company-status'>
                        <div className="row">
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Title:</Form.Label>

                                    <Controller
                                        name="title"
                                        control={control}
                                        defaultValue={isEdit?.title || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.title}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-6">
                                <Form.Group className="mb-3">
                                    <Form.Label>Link:</Form.Label>
                                    <Controller
                                        name="link"
                                        control={control}
                                        defaultValue={isEdit?.link || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                type="text"
                                                isInvalid={errors.link}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                            <div className="col-md-12">
                                <Form.Group className="mb-3">
                                    <Form.Label>Description:</Form.Label>
                                    <Controller
                                        name="description"
                                        control={control}
                                        defaultValue={isEdit?.description || ''}
                                        rules={{
                                            required: true
                                        }}
                                        render={({ field }) => (
                                            <Form.Control
                                                {...field}
                                                as="textarea"
                                                rows={4}
                                                isInvalid={errors.description}
                                            />
                                        )}
                                    />
                                </Form.Group>
                            </div>
                        </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer className="border-0">
                    <LoadingButtonWithForm
                        // isLoading={editLoading ? editLoading : addLoading}
                        name="Save"
                        form="company-status"
                    />
                </Modal.Footer>

            </Modal>
        </>
    );
};

export default AddCompanyModal;